import React, { useCallback, useState, useRef, useEffect } from "react";
import { useDropzone } from "react-dropzone";
import './App.css';
import logo from './images/Logo_Orange&White.png';
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';
import axios from "axios";
import FormCreateATicket from "./FormCreateATicket";
import FormPreConfig from "./FormPreConfig";
import FormIntegrationTesting from "./FormIntegrationTesting";
import FormFirmwareTicket from "./FormFirmwareTicket";

function App() {
  const [files, setFiles] = useState([]);
  const [tabSelected, setTabSelected] = useState(0);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [contactOptions, setContactOptions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showSuggestionsFN, setShowSuggestionsFN] = useState(false);
  const formRef1 = useRef(null);
  const formRef2 = useRef(null);
  const formRef3 = useRef(null);
  const formRef4 = useRef(null);
  const [highlightCompanyIndex, setHighlightCompanyIndex] = useState(-1);
  const [highlightContactIndex, setHighlightContactIndex] = useState(-1);
  const itemRefs = useRef([]);
  itemRefs.current = []; // Reset before rendering

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };  

  const [formData, setFormData] = useState({
    companyName: "",
    companyId: "",
    contactId: "",
    firstName: "",
    lastName: "",
    email: "",
    emailInput: "",
    isEmailMasked: false,
    summary: "",
    description: "",
    chargerType: "Artemis",
    streetAddress: "",
    city: "",
    state: "",
    zip: "",
    country: "US",
    file: null
  });

  const [formFirmwareData, setFormFirmwareData] = useState({
    companyName: "",
    companyId: "",
    contactId: "",
    firstName: "",
    lastName: "",
    email: "",
    emailInput: "",
    isEmailMasked: false,
    phone: "",
    firmwareVersion: "",
    description: "",
    chargerType: "Artemis",
    file: null
  });

  useEffect(() => {
    if (
      highlightCompanyIndex >= 0 &&
      itemRefs.current[highlightCompanyIndex]
    ) {
      itemRefs.current[highlightCompanyIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }, [highlightCompanyIndex]);  

  const handleFormReset = () => {
    setFormData({
      companyName: "",
      companyId: "",
      contactId: "",
      firstName: "",
      lastName: "",
      email: "",
      emailInput: "",
      isEmailMasked: false,
      summary: "",
      description: "",
      chargerType: "Artemis",
      streetAddress: "",
      city: "",
      state: "",
      zip: "",
      country: "US",
      file: null
    });
    setFormFirmwareData({
      companyName: "",
      companyId: "",
      contactId: "",
      firstName: "",
      lastName: "",
      email: "",
      emailInput: "",
      isEmailMasked: false,
      phone: "",
      firmwareVersion: "",
      description: "",
      chargerType: "Artemis",
      file: null
    });

    setFiles([]);
    formRef1.current?.reset(); // only works if the form is mounted
    formRef2.current?.reset(); // only works if the form is mounted
  };

  const handleEmailInputChange = (e) => {
    setFormData({
      ...formData,
      email: e.target.value,
      emailInput: e.target.value,
      isEmailMasked: false,
    });
  };

  const handleChange = async (e) => {
    if (e.target.name !== "companyName") setFormData({ ...formData, [e.target.name]: e.target.value });

    if (e.target.name === "firstName") {
      setFormData({ ...formData,
        contactId: "",
        firstName: e.target.value,
        lastName: "",
        email: "",
        emailInput: ""});
      if (e.target.value.length > 0) {
        try {
          const res = await axios.post("https://sfdc-case.starchargeamericas.com/api/contacts", {
            companyId: formData.companyId,
            firstName: e.target.value,
          }, {
            headers: {
              "x-api-key": process.env.REACT_APP_SECRET_KEY,
              "Content-Type": "multipart/form-data"
            }
          });
          if (res.data.length > 0) {
            //console.log(res.data);
            setContactOptions(res.data);
            setShowSuggestionsFN(true);
          } else {
            setContactOptions([]);
            setShowSuggestionsFN(false);
          }
        }
        catch (error) {
          console.error("Error submitting form:", error);
        }
      } else {
        setContactOptions([]);
        setShowSuggestionsFN(false);
      }
    } else {
      setContactOptions([]);
      setShowSuggestionsFN(false);
    }
    
    if (e.target.name === "companyName") {
      setFormData({ ...formData,
        companyName: e.target.value,
        companyId: "",
        contactId: "",
        firstName: "",
        lastName: "",
        email: "",
        emailInput: "",
        isEmailMasked: false });
      if (e.target.value.length > 1) {
        try {
          const res = await axios.post("https://sfdc-case.starchargeamericas.com/api/accounts", {
            companyName: e.target.value,
          }, {
            headers: {
              "x-api-key": process.env.REACT_APP_SECRET_KEY,
              "Content-Type": "multipart/form-data"
            }
          });
          if (res.data.length > 0) {
            //console.log(res.data);
            setCompanyOptions(res.data);
            setShowSuggestions(true);
          } else {
            setCompanyOptions([]);
            setShowSuggestions(false);
          }
        } catch (error) {
          console.error("Error submitting form:", error);
        }
      } else {
        setCompanyOptions([]);
        setShowSuggestions(false);
      }
    } else {
      setCompanyOptions([]);
      setShowSuggestions(false);
    }
  };

  const handleFirmwareChange = (e) => {
    setFormFirmwareData({ ...formFirmwareData, [e.target.name]: e.target.value });


  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0]; // Get the first file
    if (selectedFile) {
      setFormData({ ...formData, file: selectedFile });

      // Generate preview for display
      setFiles([
        Object.assign(selectedFile, {
          preview: URL.createObjectURL(selectedFile),
        }),
      ]);
    }
  };

  const handleFirmwareFileChange = (e) => {
    const selectedFile = e.target.files[0]; // Get the first file
    if (selectedFile) {
      setFormFirmwareData({ ...formFirmwareData, file: selectedFile });

      // Generate preview for display
      setFiles([
        Object.assign(selectedFile, {
          preview: URL.createObjectURL(selectedFile),
        }),
      ]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!recaptchaToken) {
      alert("Please complete the reCAPTCHA verification.");
      return;
    }

    // Use formData.email — not emailInput — for backend submission
    const emailToSubmit = formData.isEmailMasked
    ? formData.email
    : formData.emailInput;

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailToSubmit)) {
      alert("Please enter a valid email address.");
      return;
    }

    const data = new FormData();
    data.append("companyName", formData.companyName);
    data.append("companyId", formData.companyId);
    data.append("contactId", formData.contactId);
    data.append("firstName", formData.firstName);
    data.append("lastName", formData.lastName);
    data.append("email", emailToSubmit);
    data.append("summary", formData.summary);
    data.append("description", formData.description);
    data.append("chargerType", formData.chargerType);
    data.append("streetAddress", formData.streetAddress);
    data.append("city", formData.city);
    data.append("state", formData.state);
    data.append("zip", formData.zip);
    data.append("country", formData.country);
    data.append("recaptchaToken", recaptchaToken); // Include reCAPTCHA token
    if (formData.file) {
      data.append("file", formData.file);
    }

    try {
      await axios.post("https://sfdc-case.starchargeamericas.com/api/create-case", data, {
        headers: {
          "x-api-key": process.env.REACT_APP_SECRET_KEY,
          "Content-Type": "multipart/form-data"
        }
      });
      alert(`Ticket submitted successfully. We will contact you ASAP.`);

      // Reset form state to empty after successful submission
      setFormData({
        companyName: "",
        companyId: "",
        contactId: "",
        firstName: "",
        lastName: "",
        email: "",
        emailInput: "",
        isEmailMasked: false, 
        summary: "",
        description: "",
        chargerType: "Artemis",
        streetAddress: "",
        city: "",
        state: "",
        zip: "",
        country: "US",
        file: null
      });
      setFiles([]);
      formRef1.current.reset();
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit the ticket. Please try again later or email to service@starchargeamericas.com.");
    }
  };

  const handleFirmwareSubmit = async (e) => {
    e.preventDefault();

    /*
    
    if (!recaptchaToken) {
      alert("Please complete the reCAPTCHA verification.");
      return;
    }

    const data = new FormData();
    data.append("companyName", formFirmwareData.companyName);
    data.append("firstName", formFirmwareData.firstName);
    data.append("lastName", formFirmwareData.lastName);
    data.append("email", formFirmwareData.email);
    data.append("phone", formFirmwareData.phone);
    data.append("firmwareVersion", formFirmwareData.firmwareVersion);
    data.append("description", formFirmwareData.description);
    data.append("chargerType", formFirmwareData.chargerType);
    data.append("recaptchaToken", recaptchaToken); // Include reCAPTCHA token
    if (formFirmwareData.file) {
      data.append("file", formFirmwareData.file);
    }

    try {
      await axios.post("https://sfdc-case.starchargeamericas.com/api/create-firmware-case", data, {
        headers: {
          "x-api-key": process.env.REACT_APP_SECRET_KEY,
          "Content-Type": "multipart/form-data"
        }
      });
      alert(`Ticket submitted successfully. We will contact you ASAP.`);

      // Reset form state to empty after successful submission
      setFormFirmwareData({
        companyName: "",
        companyId: "",
        contactId: "",
        firstName: "",
        lastName: "",
        email: "",
        emailInput: "",
        isEmailMasked: false,
        phone: "",
        firmwareVersion: "",
        description: "",
        chargerType: "Artemis",
        file: null
      });
      setFiles([]);
      formRef2.current.reset();
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("Failed to submit the ticket. Please try again later or email to service@starchargeamericas.com.");
    }

    */
  };

  const navigation = [
    { name: 'Create A Ticket', href: '#', id: 0 },
    { name: 'Firmware Request', href: '#', id: 1 },
    //{ name: 'Pre Configuration Request', href: '#', id: 2 },
    //{ name: 'Integration Testing', href: '#', id: 3 },
  ]
  
  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }

  const onDrop = useCallback((acceptedFiles) => {
    setFiles(
      acceptedFiles.map((file) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    maxSize: 10 * 1024 * 1024, // 10MB limit
  });

  return (
    <div className="App">
      <div className="Content">
        <Disclosure as="nav" className="bg-black">
          {({ open }) => (
            <>
              <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <div className="flex h-16 items-center justify-between">
                  <div className="flex items-center">
                    <div className="shrink-0">
                      <img alt="StarCharge Americas Corp." src={logo} className="w-[160px]" />
                    </div>
                    <div className="hidden md:block">
                      <div className="ml-10 flex items-baseline space-x-4">
                        {navigation.map((item, index) => (
                          <a
                            key={index}
                            href={item.href}
                            onClick={() => setTabSelected(item.id)}
                            aria-current={tabSelected === item.id ? "page" : undefined}
                            className={classNames(
                              tabSelected === item.id
                                ? "bg-gray-900 text-white"
                                : "text-gray-300 hover:bg-gray-700 hover:text-white",
                              "rounded-md px-3 py-2 text-sm font-medium"
                            )}
                          >
                            {item.name}
                          </a>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Mobile menu button */}
                  <div className="-mr-2 flex md:hidden">
                    <DisclosureButton className="inline-flex items-center justify-center rounded-md bg-gray-800 p-2 text-gray-400 hover:bg-gray-700 hover:text-white focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                      <span className="sr-only">Open main menu</span>
                      {/* Conditionally render icons based on Disclosure's `open` state */}
                      {open ? (
                        <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                      ) : (
                        <Bars3Icon className="h-6 w-6" aria-hidden="true" />
                      )}
                    </DisclosureButton>
                  </div>
                </div>
              </div>

              {/* Mobile Navigation Panel */}
              <DisclosurePanel className="md:hidden">
                <div className="space-y-1 px-2 pt-2 pb-3 text-left sm:px-3">
                  {navigation.map((item, index) => (
                    <DisclosureButton
                      key={index}
                      as="a"
                      href={item.href}
                      onClick={() => setTabSelected(item.id)}
                      aria-current={tabSelected === item.id ? "page" : undefined}
                      className={classNames(
                        tabSelected === item.id
                          ? "bg-gray-900 text-white"
                          : "text-gray-300 hover:bg-gray-700 hover:text-white",
                        "block rounded-md px-3 py-2 text-base font-medium"
                      )}
                    >
                      {item.name}
                    </DisclosureButton>
                  ))}
                </div>
              </DisclosurePanel>
            </>
          )}
        </Disclosure>
        
        <header className="bg-gray-800 shadow">
          <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
            <h1 className="text-left text-3xl font-bold tracking-tight text-gray-300">
              {navigation[tabSelected].name}
            </h1>
          </div>
        </header>
        
        {/* Conditional Rendering of Forms */}
        {tabSelected === 0 && <FormCreateATicket
                                formRef={formRef1}
                                handleChange={handleChange}
                                handleFileChange={handleFileChange}
                                handleSubmit={handleSubmit}
                                handleFormReset={handleFormReset}
                                formData={formData}
                                files={files}
                                getRootProps={getRootProps}
                                getInputProps={getInputProps}
                                isDragActive={isDragActive}
                                handleRecaptchaChange={handleRecaptchaChange}
                                companyOptions={companyOptions}
                                showSuggestions={showSuggestions}
                                setFormData={setFormData}
                                setShowSuggestions={setShowSuggestions}
                                contactOptions={contactOptions}
                                showSuggestionsFN={showSuggestionsFN}
                                setShowSuggestionsFN={setShowSuggestionsFN}
                                highlightCompanyIndex={highlightCompanyIndex}
                                setHighlightCompanyIndex={setHighlightCompanyIndex}
                                highlightContactIndex={highlightContactIndex}
                                setHighlightContactIndex={setHighlightContactIndex}
                                handleEmailInputChange={handleEmailInputChange}
                                itemRefs={itemRefs}
        />}
        {tabSelected === 1 && <FormFirmwareTicket
                                  formRef={formRef2}
                                  handleFirmwareChange={handleFirmwareChange}
                                  handleFirmwareFileChange={handleFirmwareFileChange}
                                  handleFirmwareSubmit={handleFirmwareSubmit}
                                  handleFormReset={handleFormReset}
                                  formFirmwareData={formFirmwareData}
                                  files={files}
                                  getRootProps={getRootProps}
                                  getInputProps={getInputProps}
                                  isDragActive={isDragActive}
                                  handleRecaptchaChange={handleRecaptchaChange}
         />}
         {tabSelected === 2 && <FormPreConfig
                                formRef={formRef3}
                                handleRecaptchaChange={handleRecaptchaChange}
         />}
         {tabSelected === 3 && <FormIntegrationTesting
                                formRef={formRef4}
                                handleRecaptchaChange={handleRecaptchaChange}
         />}
      </div>
    </div>
  );
}

export default App;
